import React from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon';
import FocusAreaCoreIcon from '@atlaskit/icon/core/focus-area';

import { getFocusAreaIconColor } from '../../common/utils';
import type { FocusAreaHealthKey, FocusAreaStatusKey } from '../../common/utils/types';

export type FocusAreaIconProps = {
	/**
	 * Focus area status key
	 */
	status?: FocusAreaStatusKey | undefined;

	/**
	 * Focus area health key
	 */
	health?: FocusAreaHealthKey | undefined;

	/**
	 * Overrides the status color with a custom color token
	 */
	customColor?: NewCoreIconProps['color'];

	/**
	 * Determines the spacing of the icon
	 * Size has been deprecated and replaced with spacing
	 * https://hello.atlassian.net/wiki/spaces/DST/pages/3748692796
	 */
	spacing?: NewCoreIconProps['spacing'];

	/**
	 * Test id for container element
	 */
	testId?: string;

	/**
	 * Accessible description for the focus area icon
	 */
	label?: string;
};

export default function FocusAreaIcon({
	status,
	health,
	customColor,
	spacing,
	testId,
	label,
}: FocusAreaIconProps) {
	return (
		<FocusAreaCoreIcon
			color={getFocusAreaIconColor({ customColor, status, health })}
			spacing={spacing || 'none'}
			label={label || ''}
			testId={testId}
		/>
	);
}
